/**
 * MobileMockedModuleCard — an em-dash skeleton card for a module whose data
 * source does not exist yet.
 *
 * Shared by /me/supplies (BON-95, waiting on the inventory module) and
 * /me/resources (BON-96, waiting on content authoring), which had identical
 * copies of this. Both render their cards behind a single <MockedOverlay>, so
 * this draws the shape only and never claims to show real values.
 */
const EM_DASH = '—';
const ROWS = ['r1', 'r2', 'r3'] as const;
const border = '1px solid var(--nb-border)';
const subtle = 'var(--nb-subtle)';

export default function MobileMockedModuleCard({ title }: { title: string }) {
  return (
    <section style={{ background: 'var(--nb-bg)', border, borderRadius: 12, padding: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
        <h3 className="nb-display" style={{ margin: 0, fontSize: 12, letterSpacing: '0.04em' }}>
          {title}
        </h3>
        <span className="nb-eyebrow" style={{ color: subtle }}>
          {EM_DASH}
        </span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {ROWS.map((r) => (
          <div
            key={r}
            style={{
              padding: '10px 12px',
              background: 'var(--nb-surface)',
              border,
              borderRadius: 8,
            }}
          >
            <div style={{ fontSize: 12.5, fontWeight: 700, color: subtle }}>{EM_DASH}</div>
            <div style={{ fontSize: 11, color: subtle, marginTop: 4 }}>{EM_DASH}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
